// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Of5hK","subheader":"ReorderModal_subheader__ElmnO","listWrap":"ReorderModal_listWrap__1IGkQ"};